class News {
    constructor() {
        this.mobilIstBuildClass = 'news-mobile-build';
        this.windowWidth = $(window).width();
        this.newsContainer = $('.el-newsholder__current');
        this.allEntries = $('.el-newsholder__current__entry');
        this.firstColClass = $('.el-newsholder__current__col[data-col="1"]');
        this.secondColClass = $('.el-newsholder__current__col[data-col="2"]');
        this.thirdColClass = $('.el-newsholder__current__col[data-col="3"]');


        var that = this;

        that.buildit();

        $(window).resize(function () {
            that.buildit();
        });

    }

    buildit() {
        let that = this;
        that.windowWidth = $(window).width();
        if (that.windowWidth <= 619) {
            that.buildMobilView();
        } else {
            console.log('build desktop');
            that.buildDesktopView();
        }
    }

    isMobileVersion() {
        let that = this;
        if (that.newsContainer.hasClass(that.mobilIstBuildClass)) {
            return true;
        } else {
            return false;
        }
    }

    buildThirdCol() {
        let that = this;
        console.log(that.windowWidth);
        if ($('.el-newsholder').hasClass('hide-top') && that.windowWidth >= 1023) {
            console.log('dreier raster');
            return true;
        } else {
            console.log('zweier raster');
            return false;
        }
    }

    buildMobilView() {
        let that = this;
        if (!that.isMobileVersion()) {
            that.newsContainer.addClass(that.mobilIstBuildClass);
            var elemente = that.allEntries.toArray();

            // Sortiere das Array basierend auf dem data-sort Attribut
            elemente.sort(function (a, b) {
                var sortA = $(a).data('pos');
                var sortB = $(b).data('pos');
                return sortA - sortB;
            });


            $.each(elemente, function (index, element) {
                // Füge jedes dieser Elemente innerhalb des Divs mit der Klasse 'el-newsholder__current' ein
                $(element).appendTo(that.newsContainer);
            });
        }
    }

    buildDesktopView() {
        let that = this;
        if (that.windowWidth >= 619) {
            that.newsContainer.removeClass(that.mobilIstBuildClass);
            that.allEntries.remove();

            if (that.buildThirdCol() == false) {
                let haelfte = Math.ceil(that.allEntries.length / 2);

                for (var i = 0; i < that.allEntries.length; i++) {
                    if (i % 2 === 0) {
                        $(that.allEntries[i]).appendTo(that.firstColClass);
                    } else {
                        $(that.allEntries[i]).appendTo(that.secondColClass);
                    }
                }
            } else {
                that.allEntries.each(function (index) {
                    // Bestimme, zu welchem Div das Element hinzugefügt werden soll, basierend auf dem Index
                    if ((index % 3) === 0) {
                        // Füge es zum Div mit der Klasse 'eins' hinzu
                        $(this).appendTo(that.firstColClass);
                    } else if ((index % 3) === 1) {
                        // Füge es zum Div mit der Klasse 'zwei' hinzu
                        $(this).appendTo(that.secondColClass);
                    } else {
                        // Füge es zum Div mit der Klasse 'drei' hinzu
                        $(this).appendTo(that.thirdColClass);
                    }
                });
            }

        }
    }
}
